// 錯誤提示模組（可多筆同時存在）
let uid = 0

export default {
  namespaced: true,

  state: () => ({
    list: []
  }),

  mutations: {
    // 新增錯誤訊息
    PUSH(state, payload) {
      state.list.push(payload)
    },

    // 移除錯誤訊息
    REMOVE(state, id) {
      state.list = state.list.filter(item => item.id !== id)
    }
  },

  actions: {
    // 顯示錯誤訊息
    show({ commit }, options = {}) {
      const id = ++uid

      const item = {
        id,
        title: options.title || '發生錯誤！',
        desc: options.desc || '',
        class: options.class || 'text-primary',
        duration: options.duration === undefined ? 3000 : options.duration
      }

      commit('PUSH', item)

      // 自動關閉邏輯（duration = 0 表示不自動關閉）
      if (item.duration > 0) {
        setTimeout(() => {
          commit('REMOVE', id)
        }, item.duration)
      }

      return id
    },

    // 手動關閉
    close({ commit }, id) {
      commit('REMOVE', id)
    }
  }
}